<div
  class="walley-stage"
  [class.walley-stage--head]="crop === 'head'"
  [class.is-idle]="state === 'idle'"
  [class.is-wave]="state === 'wave'"
  [class.is-think]="state === 'think'"
  [class.is-walk]="state === 'walk'"
  [class.is-nod]="state === 'nod'"
  [class.is-shake]="state === 'shake'"
  [class.is-jump]="state === 'jump'"
  [class.is-look-left]="state === 'look-left'"
  [class.is-look-right]="state === 'look-right'"
  [class.is-sleep]="state === 'sleep'"
  [class.is-celebrate]="state === 'celebrate'"
  [class.is-shrug]="state === 'shrug'"
  [style.width.px]="size"
  [style.transform]="'translate(' + x + 'px, ' + y + 'px)'"
  [style.transition-duration.ms]="moveDuration"
  [attr.role]="decorative ? null : 'img'"
  [attr.aria-label]="decorative ? null : accessibleLabel"
  [attr.aria-hidden]="decorative ? 'true' : null"
  (mouseenter)="onPointerEnter()"
>
  <svg class="walley-art" [attr.viewBox]="crop === 'head' ? '18 12 204 158' : '0 0 240 310'" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <defs>
      <filter [attr.id]="artId + '-eye'" x="-100%" y="-100%" width="300%" height="300%">
        <feGaussianBlur stdDeviation="6"/>
      </filter>
      <filter [attr.id]="artId + '-shadow'" x="-50%" y="-100%" width="200%" height="300%">
        <feGaussianBlur stdDeviation="5"/>
      </filter>
    </defs>

    <ellipse class="ground-shadow" cx="120" cy="298" rx="42" ry="7" fill="#9aa6bd" opacity=".22" [attr.filter]="'url(#' + artId + '-shadow)'"/>

    <g class="walley-character">
      <rect x="108" y="154" width="24" height="16" rx="8" fill="#e4ebf3"/>
      <path d="M70 184 C66 166 94 158 120 158 C146 158 174 166 170 184 C178 198 174 224 162 246 C150 266 136 274 120 272 C104 274 90 266 78 246 C66 224 62 198 70 184 Z" fill="#f4f7fb" stroke="#7d93ad" stroke-width="4"/>
      <ellipse cx="100" cy="198" rx="16" ry="16" fill="#ffffff" opacity=".72"/>
      <path d="M104 242 v4 M104 244 h32 M136 242 v4" fill="none" stroke="#d0d8e4" stroke-width="1.7" stroke-linecap="round"/>
      <path d="M106 210 L112 226 L120 216 L128 226 L134 210" fill="none" stroke="#5b7ed0" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"/>

      <g class="walley-head">
        <path d="M27 66c-10 4-12 17-12 39s3 36 14 40l11-8V74Z" fill="#b6c0d9" stroke="#3a4a78" stroke-width="1.4"/>
        <path d="M213 66c10 4 12 17 12 39s-3 36-14 40l-11-8V74Z" fill="#b6c0d9" stroke="#3a4a78" stroke-width="1.4"/>
        <path d="M25 89v35M215 89v35" stroke="#435fba" stroke-width="2.2" stroke-linecap="round"/>
        <path d="M120 16c-54 0-85 29-89 72-2 19-1 38 5 53 8 20 29 27 84 27s76-7 84-27c6-15 7-34 5-53-4-43-35-72-89-72Z" fill="#f2f5fb" stroke="#3d5288" stroke-width="1.7"/>
        <path d="M49 43c-11 11-17 29-18 45" fill="none" stroke="#ffffff" stroke-width="5" stroke-linecap="round" opacity=".8"/>
        <path d="M187 43c11 11 17 29 18 45" fill="none" stroke="#8c9dc7" stroke-width="5" stroke-linecap="round" opacity=".65"/>
        <path d="M102 18q18-6 36 0l-4 24q-14 8-28 0Z" fill="#4164b7" stroke="#3d5288" stroke-width="1.6"/>
        <ellipse cx="112" cy="29" rx="7" ry="5" fill="#8dafef" opacity=".55"/>
        <path d="M120 44v15" stroke="#54649d" stroke-width="1.5"/>
        <path d="M51 75q8-15 25-16 44-5 88 0 18 1 25 16 7 19 0 52-3 17-18 19-50 7-102 0-15-2-18-19-7-33 0-52Z" fill="#22283b" stroke="#3d5288" stroke-width="2"/>
        <path d="M59 80q6-10 18-11 42-4 85 0" fill="none" stroke="#8b94b5" stroke-width="2" opacity=".35"/>
        <g class="walley-eyes">
          <ellipse cx="87" cy="103" rx="17" ry="23" fill="#35fcff" opacity=".5" [attr.filter]="'url(#' + artId + '-eye)'"/>
          <ellipse cx="153" cy="103" rx="17" ry="23" fill="#35fcff" opacity=".5" [attr.filter]="'url(#' + artId + '-eye)'"/>
          <ellipse cx="87" cy="103" rx="12" ry="18" fill="#36f6fa"/>
          <ellipse cx="153" cy="103" rx="12" ry="18" fill="#36f6fa"/>
          <ellipse cx="83" cy="94" rx="3" ry="5" fill="#c8ffff" opacity=".7"/>
          <ellipse cx="149" cy="94" rx="3" ry="5" fill="#c8ffff" opacity=".7"/>
        </g>
        <path d="M202 64q7 4 9 15l-3 1q-1-10-7-13Z" fill="#ff8a24"/>
        <path d="M69 155q51 10 102 0" fill="none" stroke="#8997ba" stroke-width="2" opacity=".5"/>
        <g class="eyes-closed">
          <path d="M74 100 Q87 112 100 100" fill="none" stroke="#36f6fa" stroke-width="3.5" stroke-linecap="round"/>
          <path d="M140 100 Q153 112 166 100" fill="none" stroke="#36f6fa" stroke-width="3.5" stroke-linecap="round"/>
        </g>
      </g>

      <g class="arm arm-left">
        <path d="M76 180 C50 188 30 214 34 240 C37 260 56 274 72 266 C86 258 90 238 84 216 C80 198 90 184 76 180 Z" fill="#d9e2ee" stroke="#8fa3bb" stroke-width="2.6"/>
        <path d="M64 196 C52 214 48 236 56 254" fill="none" stroke="#ffffff" stroke-width="3.5" stroke-linecap="round" opacity=".85"/>
      </g>
      <g class="arm arm-right-rest">
        <path d="M164 180 C190 188 210 214 206 240 C203 260 184 274 168 266 C154 258 150 238 156 216 C160 198 150 184 164 180 Z" fill="#d9e2ee" stroke="#8fa3bb" stroke-width="2.6"/>
        <path d="M176 196 C188 214 192 236 184 254" fill="none" stroke="#ffffff" stroke-width="3.5" stroke-linecap="round" opacity=".85"/>
      </g>
      <g class="arm arm-right-think">
        <path d="M164 182 C192 160 212 132 198 112 C186 96 166 104 164 122 C160 148 148 168 156 184 Z" fill="#d9e2ee" stroke="#8fa3bb" stroke-width="2.6"/>
      </g>

      <g class="sleep-zzz" fill="none" stroke="#7fd6ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M186 34 h10 l-10 8 h10"/>
        <path d="M202 18 h8 l-8 6 h8"/>
      </g>

      <g class="thought-bubbles" fill="#ffffff" stroke="#4768be" stroke-width="2">
        <circle cx="208" cy="52" r="4"/>
        <circle cx="222" cy="37" r="7"/>
        <circle cx="221" cy="16" r="11"/>
      </g>
    </g>
  </svg>
</div>
